<template>
  <div class="step-bar" :class="`step-${currentStep}`">
    <a class="sb-button sb-back past-step" @click="onBack">
      <div class="sb-inside-holder">
        <div class="sb-step-label"><img src="@/assets/leadcatcher-assets/arrow_back.svg" class="arrow-back" /> back</div>
      </div>
    </a>
    <a @click="onNext(2)"
        class="sb-button sb-step-2"
        :class="{ 'current-step': currentStep == 2,
                  'past-step': currentStep >= 2,
                  'enabled': currentStep == 1 && enableNext}"
    >
      <div class="sb-inside-holder">
        <div class="sb-step-number">01</div>
        <div class="sb-step-label">hello</div>
        <transition name="fade">
          <div v-if="currentStep == 2" class="is-hidden-mobile sb-step-desc">
            do you want to do and where are you thinking about selling
          </div>
        </transition>
      </div>
    </a>
    <a @click="onNext(3)"
        class="sb-button sb-step-3"
        :class="{ 'current-step': currentStep == 3,
                  'past-step': currentStep >= 3,
                  'enabled': currentStep == 2 && enableNext}"
    >
      <div class="sb-inside-holder">
        <div class="sb-step-number">02</div>
        <div class="sb-step-label">what</div>
        <transition name="fade">
          <div v-if="currentStep == 3" class="is-hidden-mobile sb-step-desc">
            do you want to do and where are you thinking about selling
          </div>
        </transition>
      </div>
    </a>
    <a @click="onNext(4)"
        class="sb-button sb-step-4"
        :class="{ 'current-step': currentStep == 4,
                  'past-step': currentStep >= 4,
                  'enabled': currentStep == 3 && enableNext }"
    >
      <div class="sb-inside-holder">
        <div class="sb-step-number">03</div>
        <div class="sb-step-label">foundation</div>
        <transition name="fade">
          <div v-if="currentStep == 4" class="is-hidden-mobile sb-step-desc">
            designing the starting point
          </div>
        </transition>
      </div>
    </a>
    <a @click="onNext(5)"
        class="sb-button sb-step-5"
        :class="{ 'current-step': currentStep == 5,
                  'past-step': currentStep >= 5,
                  'enabled': currentStep == 4 && enableNext}"
    >
      <div class="sb-inside-holder">
        <div class="sb-step-number">04</div>
        <div class="sb-step-label">define</div>
        <transition name="fade">
          <div v-if="currentStep == 5" class="is-hidden-mobile sb-step-desc">
            all the design specs we should consider
          </div>
        </transition>
      </div>
    </a>
    <a class="sb-button sb-next" @click="onNext(-1)"
        :class="{disabled: !enableNext}"
    >
      <div class="sb-inside-holder">
        <template v-if="currentStep == 1">
          <div class="sb-step-label">start</div>
        </template>
        <template v-else-if="currentStep > 1 && currentStep < 6">
          <div class="sb-step-label">next <img src="@/assets/leadcatcher-assets/arrow_next.svg" class="arrow-next" /></div>
        </template>
        <template v-if="currentStep == 6">
          <div class="sb-step-label">schedule an appointment with a consultant</div>
        </template>
      </div>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'LCStepBar',
    props: {
      currentStep: {
        type: Number,
        default: undefined
      },
      enableNext: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      onBack() {
        this.$emit('back')
      },
      onNext(step) {
        this.$emit('next', step)
      }
    }
  }
</script>

<style lang="scss" scoped>
.step-bar {
  position: fixed;
  bottom: 0px;
  z-index: 10;
  width: 100%;
  display: flex;
  align-items: flex-end;

  .sb-back,
  .sb-next,
  .sb-button {
    min-height: 80px;
  }

  .sb-button {
    // flex:1;
    transition: all .25s ease;
    width: calc(100% / 6);

    overflow: hidden;
    display: none;
    padding: 20px 10px;
    background: #573CC9;
    z-index: 0;
    position: relative;
    cursor: default;

    flex: 1;

    color: rgba(255, 255, 255, 0.3);

    &:hover {
      color: rgba(255, 255, 255, 0.3);
    }

    &.past-step {
      background: #785AD8;
      cursor: pointer;
    }

    &.enabled {
      cursor: pointer;
    }

    &.current-step {
      color: #fff;
      box-shadow: 0px 1px 10px rgba(0,0,0, 0.1);
      z-index: 10;
      padding-top: 27px;
      padding-bottom: 27px;

      @media screen and (min-width: $tablet) {
        padding-top: 20px;
        padding-bottom: 20px;
      }

      &:hover {
        color: #fff;
      }
    }
  }

  .sb-holder {
    transition: all .75s ease;
    position: absolute;
    width: 100%;
    bottom: 0px;
    right: 0px;
    text-align: right;
    z-index: -1;
    display: flex;
  }

  .sb-back {
    background: #6F50D2 !important;
  }

  .sb-next {
    color: #000;
    background: #FFD1AD;
    cursor: pointer;
    margin-left: auto;
    flex: 1;

    &.disabled {
      opacity: 0.6 !important;
      cursor: default;
    }

    &:hover {
      color: #000;
    }
  }

  .sb-step-label {
    font-size: 12px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;

    @media screen and (min-width: $tablet) {
      font-size: 15px;
    }
  }

  .sb-step-number {
    font-size: 12px;
    font-weight: bold;
    color: #A188F0;
  }

  .sb-step-desc {
    font-size: 12px;
    color: #A188F0;
  }

  .sb-back,
  .sb-next {
    flex: 0.25;

    @media screen and (min-width: $tablet) {
      flex: 1;
      text-align: center;
    }

    .sb-step-label {
      display: flex;
      flex-direction: column;

      @media screen and (min-width: $tablet) {
        display: block;
      }
    }
  }

  .sb-back {
    text-align: left;

    @media screen and (min-width: $tablet) {
      text-align: center;
    }
  }

  .sb-next {
    text-align: right;
    flex-direction: row-reverse;

    @media screen and (min-width: $tablet) {
      text-align: center;
    }

    .sb-step-label {
      flex-direction: column-reverse;
      flex-wrap: wrap-reverse;
    }
  }

  &.step-1 {
    .sb-button {
      flex: 0;
    }

    .sb-button.sb-next {
      flex: 1;
      display: flex;
      text-align: center;

      @media screen and (min-width: $tablet) {
        flex: 0.75;
      }
    }
  }

  &.step-2,
  &.step-3,
  &.step-4,
  &.step-5 {
    .sb-button {
      &.sb-back,
      &.sb-next,
      &.current-step {
        display: flex;
        align-items: center;
      }
    }
  }

  &.step-1,
  &.step-6 {
    .sb-button {
      // flex: auto;
      width: 0;
      padding: 0;
      opacity: 0;
      transform: translateY(300px);
      display: flex;
      align-items: center;
    }

    .sb-button.sb-next {
      opacity: 1;
      width: 100%;
      padding: 20px 10px;
      transform: translateY(0);
      align-items: center;
      justify-content: center;
    }

    .sb-holder {
      padding-left: 0;

      @media screen and (min-width: $tablet) {
        padding-left: 25%;
      }
    }
  }

  &.step-6 {
    .sb-button {
      flex: 0;

      &.sb-back {
        opacity: 1;
        width: 25%;
        padding: 20px 10px;
        transform: translateY(0);
        flex: 0.3;
      }

      &.sb-next {
        flex: 1;
      }
    }

    .sb-button.sb-back,
    .sb-button.sb-next {
      display: flex;
    }

    .sb-holder {
      padding-left: 0;
      width: 75%;
    }
  }
}

@media screen and (min-width: $tablet) {
  .step-bar {
    .sb-button {
      display: flex;
    }
  }
}

.arrow-back,
.arrow-next {
  display: block;
  width: 21px;

  @media screen and (min-width: $tablet) {
    display: inline-block;
    width: 27px;
  }
}

.arrow-back {
  margin-right: 10px;
}

.arrow-next {
  margin-left: 10px;
}
</style>
